module.exports = __webpack_public_path__ + "static/der-landbote-b24d4bcb90f27b76ae3d51a5a5905207.png";